import Portfolio from 'models/portfolio';

import EnrollmentDataService from 'services/data-handler-services/enrollment-data-service';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import ContentService from 'services/loader-handler-services/content-service';
import Chaplin from 'chaplin';
import _ from 'lodash';
import EF from 'ef/ef';

const PortfolioService = function () {
  if (PortfolioService.prototype._singleton) {
    return PortfolioService.prototype._singleton;
  }

  PortfolioService.prototype._singleton = this;

  this.initialize = function () {
    this.portfolio = new Portfolio();
    this.portfolio.set(CourseSettingsService.get('portfolio'));
    ContentService.applyContent(this.portfolio, 'portfolio').then(() => {
      _.each(this.portfolio.get('contents'), function (item) {
        if (item.type === 'checklist') {
          let items = [];
          _.each(item.items, function (moduleItems, moduleKey) {
            _.each(moduleItems, function (moduleItem) {
              moduleItem.module_key = moduleKey;
            });
            items = items.concat(moduleItems);
          });
          item.items = items;
        }
      });

      const userData = EnrollmentDataService.getData('portfolio_data') || {};
      const self = this;

      if (EnrollmentDataService.getData('portfolio_data')) {
        _.each(userData, function (data, key) {
          const content = self.portfolio.get('contents')[key];
          if (content && content.type === 'checklist') {
            _.each(data, function (value, item) {
              if (item === 'custom_items' && content.allow_custom) {
                content.items = content.items.concat(value);
              } else if (item === 'other-field') {
                content.other_item = value;
              } else {
                const contentItem = _.find(content.items, { key: item });
                if (contentItem) {
                  contentItem.checked = value;
                }
              }
            });
          }
        });
      }
      this.portfolio.set('user_data', userData);
    });
  };
  this.getPortfolioViewOptions = function (defaults) {
    const contents = _.map(this.portfolio.get('contents'), function (item, key) {
      item.key = key;
      return item;
    });

    const options = {
      model: this.portfolio,
      collection: new Chaplin.Collection(contents),
    };

    return _.defaults(options, defaults);
  };
  this.getChecklist = function (checklistKey) {
    return this.portfolio.get('contents')[checklistKey];
  };
  this.setChecklistItemValue = function (checklistKey, itemKey, value) {
    const userData = this.portfolio.get('user_data');
    if (!userData[checklistKey]) {
      userData[checklistKey] = {};
    }
    userData[checklistKey][itemKey] = value;

    const item = _.find(this.portfolio.get('contents')[checklistKey].items, {
      key: itemKey,
    });

    if (item !== undefined) {
      item.checked = value;
    }

    EnrollmentDataService.saveData('portfolio_data', userData);
  };
  this.addCustomChecklistItem = function (checklistKey, text) {
    const userData = this.portfolio.get('user_data');
    if (!userData[checklistKey]) {
      userData[checklistKey] = {};
    }
    let id = 0;
    if (!userData[checklistKey].custom_items) {
      userData[checklistKey].custom_items = [];
    } else {
      const items = userData[checklistKey].custom_items;
      if (items.length > 0) {
        id = items[items.length - 1].id + 1;
      }
    }

    const item = {
      checked: true,
      custom: true,
      id: id,
      key: `custom-item-${id}`,
      module_key: EF.module.get('key'),
      page_key: EF.module.currentActivity.currentPage.get('key'),
      action_tip: 'User Created Item', //TODO:  translate this....
      text: text,
    };

    userData[checklistKey].custom_items.push(item);
    this.portfolio.get('contents')[checklistKey].items.push(item);
    EnrollmentDataService.saveData('portfolio_data', userData);
  };

  this.addOtherChecklistItem = function (checklistKey, text) {
    const userData = this.portfolio.get('user_data');
    if (!userData[checklistKey]) {
      userData[checklistKey] = {};
    }

    const item = {
      checked: true,
      other: true,
      key: 'other-item',
      module_key: EF.module.get('key'),
      page_key: EF.module.currentActivity.currentPage.get('key'),
      text: text,
    };

    userData[checklistKey]['other-field'] = item;
    const checklist = this.getChecklist(checklistKey);
    checklist.other_item = item;
    EnrollmentDataService.saveData('portfolio_data', userData);
  };

  this.deleteCustomChecklistItem = function (checklistKey, itemKey) {
    const userData = this.portfolio.get('user_data');
    userData[checklistKey].custom_items = _.reject(userData[checklistKey].custom_items, {
      key: itemKey,
    });
    this.portfolio.get('contents')[checklistKey].items = _.reject(this.portfolio.get('contents')[checklistKey].items, {
      key: itemKey,
    });

    EnrollmentDataService.saveData('portfolio_data', userData);
  };
};

export default new PortfolioService();
